import { useState } from 'react';
import { ChevronDown } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
import AnimateIn, { StaggerChildren, StaggerItem } from './AnimateIn';

export default function FAQSection({ items = [], title, subtitle }) {
  const [openIndex, setOpenIndex] = useState(null);

  if (!items.length) return null;

  return (
    <section data-testid="faq-section" className="py-24 md:py-32">
      <div className="max-w-3xl mx-auto px-6 md:px-12">
        {title && (
          <AnimateIn className="text-center mb-14">
            <span className="text-xs font-bold uppercase tracking-[0.2em] text-yellow-400 mb-3 block">FAQ</span>
            <h2 className="font-['Outfit'] text-3xl sm:text-4xl font-bold text-white mb-4">{title}</h2>
            {subtitle && <p className="text-zinc-400 leading-relaxed">{subtitle}</p>}
          </AnimateIn>
        )}
        <StaggerChildren stagger={0.06} className="space-y-3">
          {items.map((item, i) => (
            <StaggerItem key={item.question || `faq-${i}`}>
              <div
                data-testid={`faq-item-${i}`}
                className={`glass-card rounded-2xl overflow-hidden transition-all duration-400 ${
                  openIndex === i ? 'border-yellow-400/15' : 'hover:border-white/10'
                }`}
              >
                <button
                  data-testid={`faq-toggle-${i}`}
                  onClick={() => setOpenIndex(openIndex === i ? null : i)}
                  className="w-full flex items-center justify-between p-5 text-left group"
                >
                  <span className="font-medium text-white text-sm pr-4 group-hover:text-yellow-400 transition-colors">
                    {item.question}
                  </span>
                  <motion.div
                    animate={{ rotate: openIndex === i ? 180 : 0 }}
                    transition={{ duration: 0.3 }}
                  >
                    <ChevronDown className="w-5 h-5 text-yellow-400 flex-shrink-0" />
                  </motion.div>
                </button>
                <AnimatePresence>
                  {openIndex === i && (
                    <motion.div
                      initial={{ height: 0, opacity: 0 }}
                      animate={{ height: 'auto', opacity: 1 }}
                      exit={{ height: 0, opacity: 0 }}
                      transition={{ duration: 0.3, ease: [0.25, 0.1, 0.25, 1] }}
                      className="overflow-hidden"
                    >
                      <div className="px-5 pb-5">
                        <p className="text-zinc-400 text-sm leading-relaxed">{item.answer}</p>
                      </div>
                    </motion.div>
                  )}
                </AnimatePresence>
              </div>
            </StaggerItem>
          ))}
        </StaggerChildren>
      </div>
    </section>
  );
}
